import React, { useState, useEffect } from "react";
import { Box, Typography, Stack, IconButton } from "@mui/material";
import School from "assets/images/school.png";
import Calender from "assets/images/calender.png";
import Gmail from "assets/images/email.png";
import Drive from "assets/images/drive.png";
import Classroom from "assets/images/classroom.png";
import Twitter from "assets/images/twitter.png";
import Facebook from "assets/images/facebook.png";
import Instagram from "assets/images/instagram.png";
import student from "assets/images/student.png";
import Blackboard from "assets/images/lms.png";

// const data = [];

export default function QuickLink({ user }) {
  const [socials, setSocials] = useState([
    user?.institute,
    user?.student,
    user?.gmail,
    user?.calender,
    user?.drive,
    user?.classroom,
    user?.twitter,
    user?.facebook,
    user?.instagram,
    user?.blackboard,
  ]);

  useEffect(() => {
    setSocials([
      user?.institute,
      user?.student,
      user?.gmail,
      user?.calender,
      user?.drive,
      user?.classroom,
      user?.twitter,
      user?.facebook,
      user?.instagram,
      user?.blackboard,
    ]);
  }, [user]);
  return (
    <Box className="quicklinks-box">
      <Box
        sx={{
          p: 1,
          bgcolor: "#82b7ea",
          minWidth: "110px",
        }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: 700, fontSize: "16px", textAlign: "center" }}
          color="white">
          Quick Links
        </Typography>
      </Box>
      <Box
        sx={{
          mt: "2px",
          p: 2,
          bgcolor: "#97c3e6",
          minWidth: "110px",
        }}
        className="quicklinks-section">
        <Stack
          spacing={4.5}
          alignItems="center"
          sx={{ height: "100%" }}
          className="quicklinks">
          {[
            School,
            student,
            Gmail,
            Calender,
            Drive,
            Classroom,
            Twitter,
            Facebook,
            Instagram,
            Blackboard,
          ].map((v, index) => (
            <IconButton
              key={Math.random()}
              color="primary"
              size="small"
              className="mt-1"
              sx={
                index === 1
                  ? {
                      p: 1,
                      height: "65px",
                      width: "65px",
                    }
                  : {
                      p: 1,
                      height: "70px",
                      width: "70px",
                    }
              }>
              <a href={socials[index]} target="_blank" rel="noreferrer">
                <img alt="..." src={v} />
              </a>
            </IconButton>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
